import { text } from '@modules/dashboard/text';

export const textBusinessLogic = {
  sowTimingLine(label: string, daysUntilSow: number | null): string {
    if (!label) return text.sowTimingUnset;
    if (daysUntilSow === null) return label;
    if (daysUntilSow === 0) return `${label} - ${text.sowDueNow}`;
    if (daysUntilSow < 0) return `${label} - ${text.sowDaysAgo(Math.abs(daysUntilSow))}`;
    return `${label} - ${text.sowDaysAway(daysUntilSow)}`;
  },
};
